export const productsData = {
  // 男和紙混粗織斜紋5口袋寬版褲
  pomelo01: {
    name: '斗六嘉東老欉文旦 3公斤禮盒',
    number: 'xxxxxxxxxx001',
    price: '699',
    img: {
      white_bg: 'pomelo-package01.jpg',
      usage: '',
    },
    alt: '',
    href: 'https://shop.muji.tw/SalePage/Index/11043786',
  },
  pomelo02: {
    name: '斗六嘉東老欉文旦3公斤禮盒 2盒',
    number: 'xxxxxxxxxx002',
    price: '1,200',
    img: {
      white_bg: 'pomelo-package02.jpg',
      usage: '',
    },
    alt: '',
    href: 'https://shop.muji.tw/SalePage/Index/11043796',
  },
  pomelo03: {
    name: '斗六嘉東老欉文旦3公斤禮盒 4盒',
    number: 'xxxxxxxxxx003',
    price: '2,200',
    img: {
      white_bg: 'pomelo-package03.jpg',
      usage: '',
    },
    alt: '',
    href: 'https://shop.muji.tw/SalePage/Index/11043800',
  },
};

export const lineupData = [
  {
    id: 1,
    current_index: 0,
    no_chips: true,
    tag: '',
    items: ['pomelo01'],
  },
  {
    id: 2,
    current_index: 0,
    no_chips: true,
    tag: '',
    items: ['pomelo02'],
  },
  {
    id: 3,
    current_index: 0,
    no_chips: true,
    tag: '',
    items: ['pomelo03'],
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://shop.muji.tw/site/cha-menu',
    img: 'report01.jpg',
    text: '良品市場茶飲快閃店',
  },
  {
    id: 2,
    link: 'https://www.muji.com/tw/muji-market-golden/',
    img: 'report02.jpg',
    text: '黃金廊道',
  },
];
